import React from "react";
import {useTranslation} from "react-i18next";
import {Button, ButtonStyles} from "../form/Button/Button";
import Modal from "./Modal";

interface IApplicableVouchersProps {
  closeFunction: () => void;
  isVisible: boolean;
  voucherTitle: string;
}

const ApplicableVouchersModal: React.FC<IApplicableVouchersProps> = (props) => {
  const {t} = useTranslation("cart");

  return (
    <Modal isVisible={props.isVisible} closeFunction={props.closeFunction}>
      <h2>{props.voucherTitle}</h2>
      <p>
        {t(
          "*Bitte beachten Sie: Der Gutschein ist nicht auf Bücher, Geschenkgutscheine und Produkte der folgenden Hersteller einlösbar: {{manufacturers}}",
        )}
      </p>
      <p>{t("Das Aufsummieren von Gutscheinen und Rabatten ist ausgeschlossen.")}</p>
      <p>{t("Der Gutschein darf nicht veröffentlicht oder in sonstiger Weise gewerblich genutzt werden.")}</p>
      <div className="center">
        <Button styles={[ButtonStyles.big]} action={props.closeFunction}>
          {t("Okay")}
        </Button>
      </div>
    </Modal>
  );
};

export default ApplicableVouchersModal;

export const excludedManufacturers =
  " Cane-line, Fast, Fatboy, Fermob, Foscarini, Gloster, Kartell, Knoll International, Muuto, USM Haller, Vitra";
